import { render, staticRenderFns } from "./AssessorForm.vue?vue&type=template&id=6fb088c7&"
import script from "./AssessorForm.vue?vue&type=script&lang=js&"
export * from "./AssessorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports